import React, { useContext } from 'react'
import RechartPie from './RechartPIE'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import { getFinalData } from 'marginanalysis/utils'
export default props => {
  const {
    whatIf = false,
    actualHeight = 170,
    actualWidth = 300,
    isEventPlanner = false,
  } = props

  const height = actualHeight
  const width = actualWidth

  const marginContext = useContext(MarginAnalysisContext)

  const { totals = [] } = getFinalData(marginContext, whatIf, isEventPlanner)

  let { actualMargin = 0, lostMargin = 0 } = totals[0] || {}

  // actualMargin = parseFloat(actualMargin) < 0 ? 0 : parseFloat(actualMargin)
  actualMargin = parseFloat(actualMargin)

  const data = [
    actualMargin >= 0 && {
      name: 'Actual Margin',
      value: parseInt(Number(actualMargin || 0).toFixed()),
      index: 0,
      getLabel: ({ name }) => name,
      color: '#f4433694',
    },
    {
      name: 'Lost Margin',
      value: parseInt(Number(lostMargin || 0).toFixed()),
      index: 1,
      getLabel: ({ name }) => name,
    },
  ].filter(d => d)

  return (
    <RechartPie
      data={data}
      height={height}
      width={width}
      title="Commercial Availability"
      // startAngle={0}
      // endAngle={360}
      legend
    />
  )
}
